import { PREVIOUSLY_VIEWED_POSTS_KEY } from 'constants/general';

type PreviouslyViewedPostsState = number[];

export const initialState: PreviouslyViewedPostsState = JSON.parse(
  localStorage.getItem(PREVIOUSLY_VIEWED_POSTS_KEY) || '[]',
);
